import { withSize } from 'react-sizeme';
import VideoPlaceholder from '../components/VideoPlaceholder';

export default withSize()(VideoPlaceholder);